import { useRef, useState } from "react";
import { classNamesOrEmpty } from "../../style/common";
import { CardVariantImageClickOverlayProps } from "./CardVariantImageClickOverlay";

export type CardVariantImageDeckCountOverlayProps = CardVariantImageClickOverlayProps & {
    count: number,
    maxCount: number | null
}

export function CardVariantImageDeckCountOverlay(props: CardVariantImageDeckCountOverlayProps) {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    return (
        <a
            onClick={() => {
                props.onLeftClick();

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }

                setIsVisible(true);
                timeoutRef.current = setTimeout(() => {
                    setIsVisible(false);
                }, 1500);
            }}
            onContextMenu={(event) => {
                if (props.onRightClick) {
                    event.preventDefault();
                    props.onRightClick();

                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }

                    setIsVisible(true);
                    timeoutRef.current = setTimeout(() => {
                        setIsVisible(false);
                    }, 1500);
                }
            }}
            className={`absolute top-0 bottom-0 left-0 right-0 cursor-pointer ${classNamesOrEmpty(props.className)}`}>
            <span className="sr-only">{props.srText}</span>

            {
                isVisible &&
                <span className="text-xl font-bold bg-secondary rounded p-1 top-[18%] left-2 absolute shadow drop-shadow">
                    {
                        props.maxCount === null
                            ? `${props.count ?? 0}`
                            : `${props.count ?? 0}/${props.maxCount}`
                    }
                </span>
            }
        </a>
    )
}